module.exports = __webpack_public_path__ + "img/9791185093222.d1d5bf99.jpg";